<template>
    <div>
        <div class="card border-primary mb-3" v-if="model">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 col-md-4 text-center border-right">
                        <div class="text-center mb-3 text-primary">
                            <i class="far fa-user-circle fa-4x"></i>
                        </div>
                        <h4>{{isEnVersion ? model.salutationDetailsEn : model.salutationDetails }} {{isEnVersion ? model.fullNameEn : model.fullName}}</h4>
                        <h5>{{isEnVersion ? model.positionDetailsEn : model.positionDetails }}</h5>
                        <div v-if="showSelectionCheckbox">
                            <div class="form-group">
                                <div class="form-check">
                                    <input
                                        v-model="model.selected"
                                        class="form-check-input"
                                        type="checkbox"
                                        id="selectedCheckbox"
                                        @change="selectionChange($event)"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="selectedCheckbox"
                                    >{{ selectionCheckboxLabel }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-8">
                        <div class="row">
                            <div class="form-group col-sm-12 col-md-4">
                                <label
                                    class="font-weight-bold"
                                    :for="'firstName' + _uid"
                                >{{$t('person.firstName')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'firstName' + _uid"
                                    :id="'firstName' + _uid"
                                >{{model.firstName}}</div>
                            </div>

                            <div class="form-group col-sm-12 col-md-4">
                                <label
                                    class="font-weight-bold"
                                    :for="'surName' + _uid"
                                >{{ $t('person.middleName') }}</label>
                                <div
                                    class="ml-2"
                                    :name="'firstName' + _uid"
                                    :id="'firstName' + _uid"
                                >{{model.middleName}}</div>
                            </div>

                            <div class="form-group col-sm-12 col-md-4">
                                <label
                                    class="font-weight-bold"
                                    :for="'lastName' + _uid"
                                >{{ $t('person.lastName')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'firstName' + _uid"
                                    :id="'firstName' + _uid"
                                >{{model.lastName}}</div>
                            </div>

                            <div class="form-group col-sm-12 col-md-4">
                                <label
                                    class="font-weight-bold"
                                    :for="'firstNameEn' + _uid"
                                >{{$t('person.firstNameEn')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'firstNameEn' + _uid"
                                    :id="'firstNameEn' + _uid"
                                >{{model.firstNameEn}}</div>
                            </div>

                            <div class="form-group col-sm-12 col-md-4">
                                <label
                                    class="font-weight-bold"
                                    :for="'middleNameEn' + _uid"
                                >{{$t('person.middleNameEn')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'middleNameEn' + _uid"
                                    :id="'middleNameEn' + _uid"
                                >{{model.middleNameEn}}</div>
                            </div>

                            <div class="form-group col-sm-12 col-md-4">
                                <label
                                    class="font-weight-bold"
                                    :for="'lastNameEn' + _uid"
                                >{{$t('person.lastNameEn')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'lastNameEn' + _uid"
                                    :id="'lastNameEn' + _uid"
                                >{{model.lastNameEn}}</div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-sm-12 col-md-6">
                                <label
                                    class="font-weight-bold"
                                    :for="'email' + _uid"
                                >{{ $t('email')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'email' + _uid"
                                    :id="'email' + _uid"
                                >{{ model.email }}</div>
                            </div>
                            <div class="form-group col-sm-12 col-md-6" v-if="isAdministration">
                                <label
                                    class="font-weight-bold"
                                    :for="'id' + _uid"
                                >{{ $t('person.gridHeaders.id')}}</label>
                                <div
                                    class="ml-2"
                                    :name="'id' + _uid"
                                    :id="'id' + _uid"
                                >{{ model.id}}</div>
                            </div>
                        </div>

                        <div>
                            <button
                                class="btn btn-link btn-primary ml-0 pl-0"
                                data-toggle="collapse"
                                :href="'#personDetailsCollapse' + _uid"
                                role="button"
                                aria-expanded="false"
                                aria-controls="personDetailsCollapse"
                            >{{ $t('buttons.details.btnText')}}</button>
                        </div>

                        <div class="col-12 collapse" :id="'personDetailsCollapse' + _uid">
                            <div class="row">
                                <div class="form-group col-sm-12 col-md-12 col-lg-8">
                                    <label
                                        class="font-weight-bold"
                                        :for="'identificationType' + _uid"
                                    >{{ indentificationNumberLabel }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'genidentificationTypeder' + _uid"
                                        :id="'identificationType' + _uid"
                                    >{{ model.personIdentification ? model.personIdentification.number : '' }}</div>
                                </div>

                                <div class="form-group col-sm-12 col-md-4">
                                    <label
                                        class="font-weight-bold"
                                        :for="'gender' + _uid"
                                    >{{ $t('person.gender')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'gender' + _uid"
                                        :id="'gender' + _uid"
                                    >{{ isEnVersion ? model.genderEn : model.gender }}</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12 col-md-4">
                                    <label
                                        class="font-weight-bold"
                                        :for="'idCardNumber' + _uid"
                                    >{{ $t('person.idCardNumber') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'idCardNumber' + _uid"
                                        :id="'idCardNumber' + _uid"
                                    >{{model.idCardNumber}}</div>
                                </div>
                                <div class="form-group col-sm-12 col-md-4">
                                    <label
                                        class="font-weight-bold"
                                        :for="'idCardDateOfIssue' + _uid"
                                    >{{ $t('person.idCardDateOfIssue') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'idCardDateOfIssue' + _uid"
                                        :id="'idCardDateOfIssue' + _uid"
                                    >{{ model.idCardDateOfIssue ? moment(model.idCardDateOfIssue).format('DD.MMM.YYYY') : '' }}</div>
                                </div>
                                <div class="form-group col-sm-12 col-md-4">
                                    <label
                                        class="font-weight-bold"
                                        :for="'idCardIssuedBy' + _uid"
                                    >{{ $t('person.idCardIssuedBy') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'idCardIssuedBy' + _uid"
                                        :id="'idCardIssuedBy' + _uid"
                                    >{{model.idCardIssuedBy}}</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'phone' + _uid"
                                    >{{$t('person.phone')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'phone' + _uid"
                                        :id="'phone' + _uid"
                                    >{{model.phone}}</div>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'mobilePhone' + _uid"
                                    >{{ $t('person.mobilePhone') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'mobilePhone' + _uid"
                                        :id="'mobilePhone' + _uid"
                                    >{{model.mobilePhone}}</div>
                                </div>
                            </div>

                            <hr />

                            <div class="row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'institution' + _uid"
                                    >{{$t('person.institution')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'institution' + _uid"
                                        :id="'institution' + _uid"
                                    >{{ isEnVersion ? model.institutionDetailsEn : model.institutionDetails }}</div>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'institutionLocation' + _uid"
                                    >{{$t('person.institutionLocation')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'institution' + _uid"
                                        :id="'institution' + _uid"
                                    >{{ isEnVersion ? model.institutionLocationDetailsEn : model.institutionLocationDetails }}</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'positionStatistic' + _uid"
                                    >{{ $t('person.positionStatistic') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'positionStatistic' + _uid"
                                        :id="'positionStatistic' + _uid"
                                    >{{ isEnVersion ? model.positionStatisticDetailsEn : model.positionStatisticDetails }}</div>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'position' + _uid"
                                    >{{ $t('person.position') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'position' + _uid"
                                        :id="'position' + _uid"
                                    >{{ isEnVersion ? model.positionDetailsEn : model.positionDetails }}</div>
                                </div>
                            </div>

                            <hr />

                            <div class="row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'titleDegree' + _uid"
                                    >{{$t('person.titleDegree')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'titleDegree' + _uid"
                                        :id="'titleDegree' + _uid"
                                    >{{ isEnVersion ? model.titleDegreeDetailsEn : model.titleDegreeDetails }}</div>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'educationDegree' + _uid"
                                    >{{ $t('person.educationDegree') }}</label>
                                    <div
                                        class="ml-2"
                                        :name="'educationDegree' + _uid"
                                        :id="'educationDegree' + _uid"
                                    >{{ isEnVersion ? model.educationDegreeDetailsEn : model.educationDegreeDetails }}</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'salutation' + _uid"
                                    >{{$t('person.salutation')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'salutation' + _uid"
                                        :id="'salutation' + _uid"
                                    >{{ isEnVersion ? model.salutationDetailsEn : model.salutationDetails }}</div>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label
                                        class="font-weight-bold"
                                        :for="'description' + _uid"
                                    >{{$t('person.description')}}</label>
                                    <div
                                        class="ml-2"
                                        :name="'description' + _uid"
                                        :id="'description' + _uid"
                                    >{{ model.description }}</div>
                                </div>
                            </div>
                        </div>

                        <slot name="actions">
                            <div v-if="!hideBtns">
                                <div class="text-center mt-3" v-if="!mergePerson">
                                    <div
                                        class="btn-group"
                                        role="group"
                                        aria-label="Person edit buttons"
                                    >
                                        <button
                                            v-if="allowEdit"
                                            type="button"
                                            class="btn btn-success"
                                            @click.stop="onEdit"
                                        >
                                            <i class="fas fa-edit mr-2"></i>
                                            {{ $t('buttons.edit.btnText')}}
                                        </button>
                                        <button
                                            v-if="!hideCloseBtn"
                                            type="button"
                                            class="btn btn-danger"
                                            @click.stop="onCancel"
                                        >
                                            <i class="fas fa-times mr-2"></i>
                                            {{ $t('buttons.close')}}
                                        </button>
                                    </div>
                                </div>
                                <div class="text-center mt-3" v-else>
                                    <div
                                        class="btn-group"
                                        role="group"
                                        aria-label="Person merge buttons"
                                    >
                                        <button
                                            type="button"
                                            class="btn btn-danger"
                                            @click.stop="onMergeRemove"
                                        >
                                            <i class="fas fa-ban mr-2"></i>
                                            {{ $t('buttons.remove.btnText')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>

            <div class="card-footer text-muted" v-if="!hideFooter">
                <span
                    class="m-1"
                    v-if="model.relatedUsername"
                >{{ $t('person.relatedToUser') + '"' + model.relatedUsername + '"' }}</span>
                <span class="m-1" v-if="model.updatedBy">
                    <span v-if="model.updatedBy">
                        {{ ' / ' + $t('lastUpdatedBy') }}
                        <strong>{{ model.updatedBy }}</strong>
                    </span>
                    <span
                        v-if="model.updatedAt"
                    >{{ ' - ' + moment(model.updatedAt).format('DD.MM.YYYY HH:mm:ss') }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Person } from "../../models/models";
import { Culture } from "../../models/enums";

export default {
    props: {
        value: {
            type: [Person, Object],
            required: false,
        },
        allowEdit: {
            type: Boolean,
            required: false,
        },
        hideBtns: {
            type: Boolean,
            required: false,
        },
        hideFooter: {
            type: Boolean,
            required: false,
        },
        hideCloseBtn: {
            type: Boolean,
            required: false,
        },
        mergePerson: {
            type: Boolean,
            required: false,
        },
        isAdministration: {
            type: Boolean,
            required: false,
        },
        showSelectionCheckbox: {
            type: Boolean,
            required: false,
        },
        selectionCheckboxLabel: {
            type: String,
            default: "",
        },
    },
    components: {},
    data() {
        return {
            model: this.value,
            moment: moment,
        };
    },
    mounted() {},
    methods: {
        onEdit() {
            if (this.allowEdit) {
                this.$emit("edit");
            }
        },
        onCancel() {
            this.$emit("cancel");
        },
        onMergeAdd() {
            this.$emit("onMergeAdd", this.model);
        },
        onMergeRemove() {
            this.$emit("onMergeRemove", this.model);
        },
        selectionChange(e) {
            if (this.model.selected) {
                this.$emit("selected", this.model.id);
            }
        },
    },
    computed: {
        isEnVersion() {
            return this.$store.getters.currentCulture === Culture.EN;
        },
        indentificationNumberLabel() {
            if (!this.model.personIdentification) {
                return this.$t("editor.tools.personIdentification");
            }

            if (this.isEnVersion) {
                return this.model.personIdentification.identificationTypeEn
                    ? this.model.personIdentification.identificationTypeEn
                    : this.$t("editor.tools.personIdentification");
            } else {
                return this.model.personIdentification.identificationType
                    ? this.model.personIdentification.identificationType
                    : this.$t("editor.tools.personIdentification");
            }
        },
    },
    watch: {
        value: function (val) {
            if (val) {
                this.model = new Person(this.value);
            }
        },
    },
};
</script>

<style scoped>
input[readonly] {
    background-color: whitesmoke;
}

textarea[readonly] {
    background-color: whitesmoke;
}
</style>
